import { useContext } from "react"

import ErrorContext from "../contexts/Error"
import useDataApi from "./useDataApi"
import { fnGetBlock } from "../services/blocks"
import { fnGetBoard } from "../services/boards"
import { fnGetPainel } from "../services/paineis"

const useCheckSubmitRegister = () => {
    const { bIsOpenErrorModal, fnOpenErrorModal } = useContext(ErrorContext)

    const [oBlockRes, fnGetBlockReq] = useDataApi(fnGetBlock)
    const [oBoardRes, fnGetBoardReq] = useDataApi(fnGetBoard)
    const [oPanelRes, fnGetPanelReq] = useDataApi(fnGetPainel)

    async function fnCheckRegister(oCheckRegister, cErrorMessage) {
        /**
         * oCheckRegister {
         *  nBlockId
         *  nBoardId
         *  nPanelId
         * }
         */

        if (!oCheckRegister) return true

        const { nBlockId, nBoardId, nPanelId } = oCheckRegister

        if (nBlockId > 0 && nBoardId > 0) {
            const oBlockResponse = await fnGetBlockReq(nBlockId)
            if (oBlockResponse?.data?.opbl_opbd_nid !== nBoardId) {
                // block change board
                fnOpenErrorModal(cErrorMessage)
                return false
            }
        }

        if (nPanelId > 0 && nBoardId > 0) {
            const oBoardResponse = await fnGetBoardReq(nPanelId, nBoardId)
            const oBoard = oBoardResponse?.data?.data?.find(oBoard => oBoard?.id === nBoardId)
            if (oBoard?.operational_panel_id !== Number(nPanelId)) {
                // board change panel
                fnOpenErrorModal(cErrorMessage)
                return false
            }
        }

        if (nPanelId > 0 && !nBoardId) {
            const oPanelResponse = await fnGetPanelReq(nPanelId)
            const oPanel = oPanelResponse?.data?.data?.find(oPanel => oPanel?.id === nPanelId)
            if (oPanel?.id !== nPanelId) {
                // panel not found
                fnOpenErrorModal(cErrorMessage)
                return false
            }
        }

        return true
    }

    const bLoading = oBlockRes.loading || oBoardRes.loading || oPanelRes.loading

    return [fnCheckRegister, bIsOpenErrorModal, bLoading]
}

export default useCheckSubmitRegister